<div class="container">
  <div class="row">
    <div class="col-sm-3 web-display"></div>
    <div class="col-md-4 col-12 col-sm-6 text-center web-display pt-2">
      <img width="50%" src="assets/img/logo.png">
    </div>
    <div class="col-sm-3 web-display"></div>

    <div class="col-md-6 col-12 jetsinif-class-head text-left pt-3">
      <h3>{{ virtualClassModel.VirtualClassName }}</h3>
      <h6>Toplam {{ NumberOfStudents }} Öğrenci</h6>
    </div>
    <div class="col-md-6 col-12 text-right mobile-display pt-5 mt-n3">
      <img width="20%" src="assets/img/logo.png">
    </div>

  </div>
</div>

<div class="container jetsinif-backgorund pt-5">
  <div class="row">
    <div class="col-md-12 col-xl-9 col-12 col-sm-12">
      <div class="container container-track active" id="container-all">
        <div class="row" id="jetsinif-tracks">

        
          

        </div>
      </div>

      <div class="container container-track" id="container-sunum" style="display: none">
        <div class="row">

          <div class="col-md-12 col-12 col-sm-12 col-xl-12 pt-3 text-center">
            <div class="konusan-user-sunum text-center">
              <video autoplay id="localVideoSunum"></video>
              <div class="row">
                <div class="col-md-6 col-12 col-sm-6 text-center col-xl-3">

                  <div class="jetsinif-user-2">
                  </div>

                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      
    </div>



    <div class="col-md-12 col-xl-3 col-12 col-sm-12 pt-1">
      <div class="row">
        <div class="col-12 col-md-12 col-sm-12 col-xl-12">
          <div class="card mt-3 tab-card">
            <div class="card-header tab-card-header">
              <ul class="nav nav-tabs card-header-tabs" id="myTab" role="tablist">
                <li class="nav-item">
                  <a class="nav-link" id="one-tab" data-toggle="tab" href="#one" role="tab" aria-controls="One"
                    aria-selected="true">Profilim</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="two-tab" data-toggle="tab" href="#two" role="tab" aria-controls="Two"
                    aria-selected="false">Mesajlaşma</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" id="three-tab" data-toggle="tab" href="#three" role="tab" aria-controls="Three"
                    aria-selected="false">Katılımcılar</a>
                </li>
              </ul>
            </div>

            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="one" role="tabpanel" aria-labelledby="one-tab">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="text-center card-box">
                      <div class="member-card pt-2 pb-2">
                        <alert type="warning" *ngIf="isJoined == false" [dismissible]="false"> Canlı derse bağlı
                          değilsiniz</alert>
                        <alert type="success" *ngIf="isJoined == true" [dismissible]="false"><i
                            class="fas fa-podcast"></i> Canlı derse bağlandınız</alert>
                        <div class="member-track">
                          <audio autoplay id="localAudio0"></audio>
                          <video autoplay id="localVideo1"></video>
                        </div>
                        <div class="pt-2">
                          <span class="student-name"> Öğrenci İsmi :</span><span class="student-name-2">
                            {{connector.displayName}} </span>
                        </div>
                        <div class="pt-2" hidden>
                          <span class="student-name"> Öğrenci Numarası :</span><span class="student-name-2">
                            6598715648</span>
                        </div>

                        <ul class="social-links list-inline pt-2">
                          <li class="list-inline-item" >
                            <a title="Video Aç/Kapa" (click)="toggleVideo()"  data-placement="top" data-toggle="tooltip" class="tooltips" href="javascript:;"
                              data-original-title="">
                              <i class="fas fa-video"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a title="Ses Aç/Kapa" data-placement="top" data-toggle="tooltip" class="tooltips" href=""
                              data-original-title="Twitter">
                              <i class="fas fa-microphone"></i>
                            </a>
                          </li>
                          <li class="list-inline-item" hidden>
                            <a id="test-connect" title="" data-placement="top"
                              data-toggle="tooltip" class="tooltips" href="javascript:;" data-original-title="Katıl">
                              <i class="fas fa-desktop"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a id="test-unload" title="" data-placement="top" data-toggle="tooltip" class="tooltips"
                              href="javascript:;" data-original-title="Ayrıl">
                              <i class="fas fa-sign-out-alt"></i>
                            </a>
                          </li>
                        </ul>
                        <ul class="social-links list-inline pt-2">
                          <li class="list-inline-item" hidden>
                            <a title="" data-placement="top" data-toggle="tooltip" class="tooltips" href=""
                              data-original-title="Facebook">
                              <i class="fas fa-volume-up"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a *ngIf="isInstructor" id="test-switch" title="Sunum" data-placement="top" data-toggle="tooltip"
                              class="tooltips" href="javascript:;" data-original-title="Sunum">
                              <i class="uil uil-presentation-teacher"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a  id="test-change" title="" data-placement="top" data-toggle="tooltip"
                              class="tooltips" href="javascript:;" data-original-title="El Kaldır">
                              <i class="fas fa-hand-paper"></i>
                            </a>
                          </li>
                          <li class="list-inline-item">
                            <a title="" data-placement="top" data-toggle="tooltip" class="tooltips" href=""
                              data-original-title="Ayarlar">
                              <i class="fas fa-cog"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="row">
                  <ul class="jetsinif-screen-menu mx-auto text-center">
                    <li><a id="container-toggle-sunum" class="btn-container-toggle" href="javascript:;">Sunum</a></li>
                    <li><a id="container-toggle-all" class="btn-container-toggle" href="javascript:;">Tüm Sınıf</a></li>
                  </ul>
          
          
                </div>
              </div>
              <div class="tab-pane fade p-3" id="two" role="tabpanel" aria-labelledby="two-tab">
                <div class="col-md-12 col-xl-12  pt-3">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="messaging">
                        <div class="inbox_msg">

                          <div id="messages" class="msg_history">
                            <div
                              [ngClass]="{incoming_msg : message.isOutgoing == false, outgoing_msg: message.isOutgoing == true}"
                              *ngFor="let message of messages">
                              <div *ngIf="message.isOutgoing == false" class="incoming_msg_img">
                                <img src="https://ptetutorials.com/images/user-profile.png" alt="sunil">
                              </div>
                              <div
                                [ngClass]="{sent_msg : message.isOutgoing == true, received_msg : message.isOutgoing == false}">
                                <div *ngIf="message.isOutgoing == false" class="received_withd_msg">
                                  <span class="name">{{message.name}}</span>
                                  <p>
                                    {{message.text}}
                                  </p>
                                  <span class="time_date">
                                    {{ message.time | date:'dd.MM.yyyy HH:mm' }}
                                  </span>
                                </div>
                                <p *ngIf="message.isOutgoing == true">
                                  {{message.text}}
                                </p>
                                <span *ngIf="message.isOutgoing == true" class="time_date ">
                                  {{ message.time | date:'dd.MM.yyyy HH:mm' }}
                                </span>
                              </div>
                            </div>

                          </div>
                          <div class="type_msg">
                            <div class="input_msg_write">
                              <input [(ngModel)]="message" type="text" class="write_msg"
                                placeholder="Bir mesaj yazın" />
                              <button (click)="sendMessage(message)" class="msg_send_btn" type="button">
                                <i class="fa fa-paper-plane" aria-hidden="true"></i>
                              </button>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="tab-pane fade p-3" id="three" role="tabpanel" aria-labelledby="one-tab">

                <div class="row">
                  <div class="col-md-12 col-12 text-left">
                    <ul class="jetsinif-katilimci list-inline">
                      <li *ngFor="let participant of participants">
                        {{participant._displayName}} <span class="jetsinif-katilimci-i" hidden><i class="fas fa-video"></i><i class="fas fa-microphone"></i>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>


              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<!--  -->
<div style="display: none" id="template-remote">

  <div class="col-md-6 col-12 col-sm-6 text-center col-lg-3  col-xl-3 pt-3">
    <div class="jetsinif-user">
      <audio autoplay></audio>
      <video autoplay></video>
    </div>
    <div class="jetsinif-background-info">
      <div class="row">
        <div class="col-md-7 col-7">
          <span class="jetsinif-user-name"></span>
        </div>
        <div class="col-md-5 col-5">
          <div class="row">
            <div class="col-md-5 col-6" style="display: none;">
              <div class="yuvarlak">
                <i class="fas fa-video"></i>
              </div>
            </div>
            <div class="col-md-5 col-6" style="display: none;">
              <div class="yuvarlak-1">
                <i class="fas fa-microphone-slash"></i>
              </div>
              <div class="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>